// components/FormularSesizare/steps/Step3ElementeSuplimentare.jsx

import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Icon from "@mui/material/Icon";

// Soft UI Components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function Step3ElementeSuplimentare({ formData, handleChange, customColors, errors = {} }) {
  return (
    <SoftBox p={3}>
    <SoftTypography variant="h5" fontWeight="bold" mb={3} color={customColors.primary.main}>
      Elemente suplimentare
    </SoftTypography>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <SoftBox mb={3} p={3} border="1px solid" borderColor={customColors.secondary.main} borderRadius="lg" bgcolor={customColors.secondary.focus}>
          <SoftTypography variant="body2" fontWeight="regular" color={customColors.secondary.dark}>
            <Icon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1, color: customColors.secondary.dark }}>info</Icon>
            Toate informațiile furnizate în acest formular vor fi tratate cu confidențialitate și vor fi utilizate doar în scopul soluționării sesizării dumneavoastră.
          </SoftTypography>
        </SoftBox>
      </Grid>
      <Grid item xs={12}>
        <SoftBox 
          p={2} 
          border={errors.acordGDPR ? "2px solid" : "1px solid"} 
          borderColor={errors.acordGDPR ? "error.main" : "transparent"}
          borderRadius="lg"
        >
          <FormControlLabel
            control={
              <Checkbox 
                checked={formData.acordGDPR}
                onChange={handleChange}
                name="acordGDPR"
                required
                sx={{ color: errors.acordGDPR ? '#f44336' : customColors.primary.light, '&.Mui-checked': { color: customColors.primary.main } }}
              />
            }
            label={
              <SoftTypography variant="button" color={errors.acordGDPR ? "error" : "text"}>
                Sunt de acord cu prelucrarea datelor mele personale în conformitate cu Regulamentul General privind Protecția Datelor (GDPR)*
              </SoftTypography>
            }
          />
          {errors.acordGDPR && (
            <SoftTypography variant="caption" color="error" sx={{ display: 'block', mt: 1, ml: 4.5 }}>
              {errors.acordGDPR}
            </SoftTypography>
          )}
        </SoftBox>
      </Grid>
    </Grid>
  </SoftBox>
  );
}

Step3ElementeSuplimentare.propTypes = {
  formData: PropTypes.shape({
    acordGDPR: PropTypes.bool,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  customColors: PropTypes.shape({
    primary: PropTypes.shape({
      main: PropTypes.string,
      light: PropTypes.string,
      dark: PropTypes.string,
      focus: PropTypes.string,
    }),
    secondary: PropTypes.shape({
      main: PropTypes.string,
      focus: PropTypes.string,
      dark: PropTypes.string,
    }),
  }).isRequired,
  errors: PropTypes.object,
};

export default Step3ElementeSuplimentare;
